/** Shared cell padding and borders for the My Reports table body. */
export const CELL_SX = {
  fontSize: '12px',
  py: 0.5,
  px: 1,
  borderBottom: '1px solid',
  borderColor: 'v4.border',
} as const;

// Timestamps read as one line or not at all — "26 Dec 2025, 11:34 AM" broken over
// four lines was the worst of the bunched-column symptoms. The 170px Created
// column comfortably fits it, so nowrap can't cause an overflow here.
export const NOWRAP_COLUMN_KEYS = new Set(['createdAt']);

/**
 * Marks the pin and default controls, which are revealed on row hover or focus.
 *
 * They stay mounted and focusable rather than being conditionally rendered — a
 * hover-only control that does not exist is unreachable by keyboard.
 */
export const ROW_ACTION_REVEAL_CLASS = 'report-row-action-reveal';
